module.exports = WHCore.dependencies["react-dom"];